<div class="card-header">
    {{floorPlan.name}}
    <ng-container *ngTemplateOutlet="addOn"></ng-container>
</div>
<div class="floor-plan" id="floor-plan_{{floorPlan.id}}">
    <ng-content></ng-content>
    <img class="floor-plan-img" appB64img [api]="viewSet" [imgid]="floorPlan.id">
</div>
